<template>
  <section class="user-index-container">
    <base-header v-bind="headers"
    />
    <search-header
      class="search-header"
      v-bind="searchHeader"
      :params="list.params"
      @handleSearch="handleSearchs"
    ></search-header>
    <base-table
      v-bind="list"
      v-on:handleSelectionChange="handleSelectKeyChange"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
      @handleStatus="handleModelStatus"
    ></base-table>
    <form-dialog
      ref="addDialog"
      :loading="addFormLoading"
      :form="addForm"
      :rules="addRules"
      :buttons="addButtons"
      :formItems="addFormItems"
      v-on:handleConfirm="handleConfirmAdd"
      v-on:handleConfirmRole="handleConfirmRole"
    ></form-dialog>
  </section>
</template>

<script>
import user from './user'
const columns = [
  {
    prop: 'username',
    label: '用户名',
    scopeType: 'link',
    href: '/memberManage/user/create',
    width: '122px'
  },
  {
    prop: 'email',
    label: '电子邮箱',
    minWidth: '120px'
  },
  {
    prop: 'userExt.realname',
    label: '真实姓名',
    minWidth: '120px'
  },
  {
    prop: 'roleNames',
    label: '所属角色',
    minWidth: '120px'
  },
  {
    prop: 'isBlack',
    label: '状态',
    scopeType: 'switch',
    type: 'Status',
    enableText: '加入黑名单',
    disableText: '移出黑名单'
  }
]

export default {
  name: 'userIndex',
  mixins: [user],
  data () {
    return {
      list: {
        columns,
        showSelection: false,
        api: 'fetchMemberManageUserPage',
        params: { 'key': '' },
        handleColumn: []
      },
      headers: {
        buttons: [],
        title: '投稿人列表',
        showAlertIcon: false,
        content: ''
      },
      searchHeader: {
        searchItems: [
          {
            type: 'searchInput',
            value: 'key',
            placeholder: '请输入关键字'
          }
        ]
      }
    }
  },
  activated () {
    if (this.$route.query.type === 'list') {
      this.fetchTableApi()
      this.$router.push({ query: { type: '' } })
    }
  },
  methods: {
    // 顶部操作按钮
    handleSearchs (data) {
      this.fetchTableApi()
    },
    handleHeaderCreate () {
      this.$refs.addDialog.showDialog()
    },
    handleModelStatus (row, index) {
      if (!row.otherExt.black) {
        this.fetchMemberManageUserOn([row.id])
      } else {
        this.fetchMemberManageUserOff([row.id])
      }
    },
    // 启用
    fetchMemberManageUserOn (ids, type) {
      this.list.loading = true
      this.$request.fetchMemberManageUserOn({ ids: ids, type: this.type }).then(res => {
        if (res.code === 200) {
          this.fetchTableApi()
          this.type = 1
        } else if (res.code === 14023) {
          this.type = 2
          this.fetchTableApi()
        }
        this.hideMsgDialog()
      }).then(this.hideTableLoading)
        .catch(this.hideTableLoading)
    },
    // 禁用
    fetchMemberManageUserOff (ids, type) {
      this.list.loading = true
      this.$request.fetchMemberManageUserOff({ ids: ids, type: this.type }).then(res => {
        if (res.code === 200) {
          this.type = 1
          this.fetchTableApi()
        } else if (res.code === 14023) {
          this.type = 2
          this.fetchTableApi()
        }
        this.hideMsgDialog()
      }).then(this.hideTableLoading)
        .catch(this.hideTableLoading)
    },
    fetchTableCallBack (res) {
      if (res.code === 200) {
        this.list.data = res.data.content.map((d, i) => {
          d.disabled = !d.managerAble
          d.disabledStatus = !d.deleteAble
          d.isBlack = !d.otherExt.black
          return d
        })
        this.list.totalCount = res.data.totalElements
      }
    }
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.box-items{
    padding: 0 9px;
  }
</style>
